/**
 * Sequência monotônica por sessão para ordering guarantees.
 */

const STORAGE_KEY = 'GOMARKE_SESSION_SEQ_V1';
const memoryCounters = new Map<string, number>();

function loadCounters(): Map<string, number> {
  if (typeof window === 'undefined') return memoryCounters;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return memoryCounters;
    const parsed = JSON.parse(raw) as Record<string, number>;
    return new Map(Object.entries(parsed));
  } catch {
    return memoryCounters;
  }
}

function persistCounters(counters: Map<string, number>): void {
  if (typeof window === 'undefined') return;
  try {
    const obj = Object.fromEntries(counters);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
  } catch {
    // quota
  }
}

export function nextSessionSequence(sessionId: string): number {
  const counters = loadCounters();
  const next = (counters.get(sessionId) ?? 0) + 1;
  counters.set(sessionId, next);
  memoryCounters.set(sessionId, next);
  persistCounters(counters);
  return next;
}

export function getCurrentSessionSequence(sessionId: string): number {
  const counters = loadCounters();
  return counters.get(sessionId) ?? memoryCounters.get(sessionId) ?? 0;
}

export function _testResetSessionSequences(): void {
  memoryCounters.clear();
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
  }
}
